<template>
  <button
    type="button"
    v-bind="$attrs"
    :class="`ml-4 box-border h-10 border-4 border-${color} `"
    style="background: rgba(0, 0, 0, 0.5)"
    disabled
  >
    <div class="flex flex-row items-center justify-center">
      <div class="flex">
        <ApprovedIcn width="20px" height="20px" class="mr-1" />
        <span class="text-lg text-white leading-tight font-bold">確認済</span>
      </div>
    </div>
  </button>
</template>

<script>
import ApprovedIcn from '@/assets/icons/approved-green.svg?inline'
export default {
  name: 'AppApprovedBtn',
  props: {
    color: String,
  },

  components: { ApprovedIcn },
}
</script>
<style lang="scss" scoped>
button {
  border-radius: 20px;
  width: 510px;
}

.yellow-circle {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: #f0c000;
  margin-left: 4px;
  margin-right: 4px;
}
</style>
